import React from "react";

const Sidebar = ({ labels, onSelectSection }) => {
  return (
    <div className="h-screen w-64 bg-gray-800 text-white flex flex-col">
      <nav className="mt-10">
        {labels.map((label, index) => (
          <a
            key={index}
            href={`#${label.toLowerCase().replace(/ /g, "-")}`}
            onClick={(e) => {
              onSelectSection(label);
            }}
            className=" block py-2.5 px-4 rounded transition duration-200 hover:bg-gray-700 hover:text-white"
          >
            {label}
          </a>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
